<div class="container-fluid dashboard">

  <!-- Header + date-range filter -->
  <div class="row align-items-center mb-2">
    <div class="col-md-6">
      <h5 class="mb-0">Dashboard</h5>
      <small class="text-muted">{{ rangeLabel }}</small>
    </div>
    <div class="col-md-6 text-md-end mt-2 mt-md-0">
      <div class="btn-group btn-group-sm flex-wrap" role="group">
        <button *ngFor="let r of ranges" type="button" class="btn"
          [class.btn-primary]="activeRange === r.key"
          [class.btn-outline-primary]="activeRange !== r.key"
          (click)="setRange(r.key)">{{ r.label }}</button>
      </div>
      <button class="btn btn-sm btn-light ms-2" (click)="refresh()" [disabled]="loading">
        {{ loading ? '…' : '↻' }}
      </button>
    </div>
  </div>

  <!-- Summary cards -->
  <div class="row">
    <div class="col-xl-3 col-md-6">
      <div class="card stat-card">
        <div class="card-body">
          <p class="stat-label">New Customers</p>
          <h3 class="stat-value">{{ newCustomers }}</h3>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="card stat-card">
        <div class="card-body">
          <p class="stat-label">Total Scans</p>
          <h3 class="stat-value">{{ totalScans }}</h3>
          <small class="text-muted">
            <span class="dot dealer"></span> Dealer {{ dealerScans }}
            &nbsp; <span class="dot normal"></span> Normal {{ normalScans }}
          </small>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="card stat-card">
        <div class="card-body">
          <p class="stat-label">Payout (₹)</p>
          <h3 class="stat-value">{{ payoutTotal | number }}</h3>
          <small class="text-muted">Paid {{ payoutPaid | number }} · Pending {{ payoutPending | number }}</small>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6" *ngIf="hasMarketing">
      <div class="card stat-card">
        <div class="card-body">
          <p class="stat-label">Marketing Spend ({{ spendCurrency }})</p>
          <h3 class="stat-value">{{ spendTotal | number }}</h3>
          <small class="text-muted">Delivered {{ msgDelivered }} · Read {{ msgRead }}</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Charts row 1 -->
  <div class="row">
    <div class="col-xl-8">
      <div class="card">
        <div class="card-header"><h6 class="mb-0">Scans per day — Dealer vs Normal</h6></div>
        <div class="card-body"><div class="chart-box"><canvas baseChart [type]="'line'" [data]="scansLine" [options]="lineOptions"></canvas></div></div>
      </div>
    </div>
    <div class="col-xl-4">
      <div class="card">
        <div class="card-header"><h6 class="mb-0">Scan type split</h6></div>
        <div class="card-body"><div class="chart-box"><canvas baseChart [type]="'doughnut'" [data]="typeDoughnut" [options]="doughnutOptions"></canvas></div></div>
      </div>
    </div>
  </div>

  <!-- Charts row 2 -->
  <div class="row">
    <div class="col-xl-6">
      <div class="card">
        <div class="card-header"><h6 class="mb-0">New customers per day</h6></div>
        <div class="card-body"><div class="chart-box"><canvas baseChart [type]="'line'" [data]="customersLine" [options]="lineOptions"></canvas></div></div>
      </div>
    </div>
    <div class="col-xl-3">
      <div class="card">
        <div class="card-header"><h6 class="mb-0">Redemption status</h6></div>
        <div class="card-body"><div class="chart-box"><canvas baseChart [type]="'doughnut'" [data]="statusDoughnut" [options]="doughnutOptions"></canvas></div></div>
      </div>
    </div>
    <div class="col-xl-3">
      <div class="card">
        <div class="card-header"><h6 class="mb-0">Top products</h6></div>
        <div class="card-body"><div class="chart-box"><canvas baseChart [type]="'bar'" [data]="topProductsBar" [options]="barOptions"></canvas></div></div>
      </div>
    </div>
  </div>

</div>
